import { render, staticRenderFns } from "./accounting.vue?vue&type=template&id=70ccba4e&scoped=true&"
import script from "./accounting.vue?vue&type=script&lang=js&"
export * from "./accounting.vue?vue&type=script&lang=js&"
import style0 from "./accounting.vue?vue&type=style&index=0&id=70ccba4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ccba4e",
  null
  
)

export default component.exports